module.exports = __webpack_public_path__ + "static/media/drum.2a093d73.svg";